module.exports = __webpack_public_path__ + "img/12_21.aafe4b42.png";